import React, { useEffect } from 'react';
import { useBootstrap } from '../context/BootstrapContext.jsx';
import { useLucideIcons, usePageStyles } from '../hooks/usePageAssets.js';
import { resolveStaticUrl } from '../utils/staticAssets.js';

const MaintenancePage = () => {
  const bootstrap = useBootstrap();
  const settings = bootstrap?.maintenance_mode || {};
  const authenticated = Boolean(bootstrap?.authenticated);

  usePageStyles([resolveStaticUrl('css/maintenance.css')]);
  useLucideIcons([authenticated, settings.message]);

  useEffect(() => {
    document.body.classList.add('maintenance-body');
    return () => document.body.classList.remove('maintenance-body');
  }, []);

  return (
    <main className="maintenance-page">
      <div className="maintenance-backdrop-mark" aria-hidden="true">H</div>
      <section className="maintenance-shell" aria-labelledby="maintenance-title">
        <header className="maintenance-brand">
          <img src={resolveStaticUrl('images/logo.png')} alt="Tim Hortons" />
          <span>Hat Trick</span>
        </header>

        <div className="maintenance-visual" aria-hidden="true">
          <div className="maintenance-orbit maintenance-orbit-one" />
          <div className="maintenance-orbit maintenance-orbit-two" />
          <div className="maintenance-tool"><i data-lucide="wrench" /></div>
        </div>

        <div className="maintenance-copy">
          <span className="maintenance-eyebrow">Mantenimiento en curso</span>
          <h1 id="maintenance-title">Volvemos pronto</h1>
          <p>{settings.message}</p>
        </div>

        <div className="maintenance-note">
          <i data-lucide="sparkles" />
          <span>Estamos preparando una mejor experiencia para tu operación.</span>
        </div>

        <div className="maintenance-session-actions">
          {authenticated ? (
            <a href={bootstrap?.routes?.logout || '/logout'} className="maintenance-access-link">
              <i data-lucide="log-out" /> Cerrar sesión
            </a>
          ) : (
            <a href={bootstrap?.routes?.login || '/login'} className="maintenance-access-link">
              <i data-lucide="shield-check" /> Acceso administrativo
            </a>
          )}
        </div>
      </section>
    </main>
  );
};

export default MaintenancePage;
